import { PRIVATE_DOMAIN_ID } from '@ergeon/help-components';

export const WIKI_API_HOST = process.env.API_HOST;
export const WIKI_LEVEL = process.env.NODE_ENV;
export const WIKI_DOMAIN = PRIVATE_DOMAIN_ID;

export const WIKI_TITLE = 'Company Wiki';
export const WIKI_ALL_SECTIONS_LABEL = 'All sections';

export const WIKI_PALETTE_LABELS = {
  dialog: 'Search the wiki',
  placeholder: 'Search the wiki…',
  quickLinks: 'Sections',
};

export const PAGE_PADDING_CLASSES = 'px-4 py-8 md:px-8 md:py-10';
